var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({display:_vm.msgInfo.isShow?'':'none'})},[_c('div',{staticClass:"weui-mask_transparent"}),_vm._v(" "),_c('div',{staticClass:"weui-toast"},[_c('i',{staticClass:"weui-icon_toast",class:_vm.iconClass}),_vm._v(" "),_c('p',{staticClass:"weui-toast__content"},[_vm._v(_vm._s(_vm.msgInfo.msg))])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7aea2988","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/loading-toast/LoadingToast.vue
// module id = 234
// module chunks = 0